import { ref } from "vue";
import { defineStore } from "pinia";
import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.VUE_APP_PINIA_SECRET_KEY || "vIDOjgyxQRzH9Izb81lMhqhMUY9F6CWw";

const key = "environment";

export const useEnvironmentStore = defineStore(
  key,
  () => {
    // state

    const environment = ref(null);

    // actions

    const set = (value) => {
      environment.value = value;
    };

    const unset = () => {
      environment.value = null;
    };

    return { environment, set, unset };
  },
  {
    persist: {
      key,
      storage: localStorage, // localStorage or sessionStorage
      serializer: {
        serialize: (value) =>
          CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString(),
        deserialize: (value) => {
          const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decrypted);
        },
      },
    },
  },
);
